import React from 'react';
import TooltipMenu from 'components/pure/tooltips/TooltipMenu';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenuButton from 'components/pure/utils/DropDownMenuButton';
import AddToReviewDialog from 'components/pure/sharing/coaching/AddToReviewDialog';
import CoachMeSource from 'sources/CoachMeSource';
import FileUploadActions from 'actions/files/FileUploadActions';
import CallCardActions from '@store/call-card/CallCardActions';

export default class RepQuickActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showShareToCoachingPlan: false,
      coachMe: props.isCoachingRequested,
    };

    this.onToggleCoachMe = this.onToggleCoachMe.bind(this);
  }

  async onToggleCoachMe() {
    this.setState({coachMe: !this.state.coachMe});
    const currentCoachMe = this.props.isCoachingRequested;
    if (this.props.newCallCard) {
      return CallCardActions.setCoachMe(this.props.fileUpload.id, !currentCoachMe);
    } else {
      await CoachMeSource.postCoachMe(this.props.fileUpload, !currentCoachMe);
      return FileUploadActions.findFilesById([this.props.fileUpload.id]);
    }
  }

  render() {
    const {showShareToCoachingPlan, coachMe} = this.state;
    const {fileUpload, onShowMenu, authUser, caller, button} = this.props;

    return (
      <div>
        <div className="coaching-quick-actions">
          <TooltipMenu
            menu={
              <Menu>
                <MenuItem
                  primaryText="Add To Coaching Plan"
                  onClick={() => this.setState({showShareToCoachingPlan: true})}
                />

                {coachMe ? (
                  <MenuItem primaryText="Cancel Coaching Request" onClick={this.onToggleCoachMe} />
                ) : (
                  <MenuItem primaryText="Request Coaching" onClick={this.onToggleCoachMe} />
                )}
              </Menu>
            }
            onShowMenu={onShowMenu}>
            {button ?? (
              <DropDownMenuButton size="small" variant="outlined" fullWidth>
                Request Coaching
              </DropDownMenuButton>
            )}
          </TooltipMenu>
        </div>
        <AddToReviewDialog
          open={showShareToCoachingPlan}
          fileUpload={fileUpload}
          callerTeamId={caller.teamId}
          authUser={authUser}
          onSubmit={() => this.setState({showShareToCoachingPlan: false})}
          onClose={() => {
            this.setState({showShareToCoachingPlan: false});
          }}
        />
      </div>
    );
  }
}
